import { getLabel } from "../../../../hooks/use-labels";
import HexButton from "../../../../ui-kit/HexButtons";
import ModalTitle from "../../../HexModal/ModalTitle";
import PaymentSuccess from "../../assets/payment-success.gif";

const SuccessfulPayment = ({ onButtonClick, paymentTitle, paymentMessage, buttonLabel }) => {
  return (
    <div className="text-center">
      <ModalTitle
        text={paymentTitle || getLabel("paymentSuccessfulLabel")}
        className={"mb-20"}
      />
      <div className="success-status-image-container">
        <img
          src={PaymentSuccess}
          alt="payment-success"
          className="payment-status-image"
        />
      </div>

      <div className="payment-message">{paymentMessage}</div>
      <HexButton
        label={buttonLabel}
        onClick={onButtonClick}
        type="primary"
        size="md"
        htmlType="submit"
        className="full-width try-again-button"
      />
    </div>
  );
};

export default SuccessfulPayment;
